import { render, staticRenderFns } from "./LoadingBox.vue?vue&type=template&id=72ebe06a&scoped=true&"
import script from "./LoadingBox.vue?vue&type=script&lang=js&"
export * from "./LoadingBox.vue?vue&type=script&lang=js&"
import style0 from "./LoadingBox.vue?vue&type=style&index=0&id=72ebe06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ebe06a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ebe06a')) {
      api.createRecord('72ebe06a', component.options)
    } else {
      api.reload('72ebe06a', component.options)
    }
    module.hot.accept("./LoadingBox.vue?vue&type=template&id=72ebe06a&scoped=true&", function () {
      api.rerender('72ebe06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/LoadingBox.vue"
export default component.exports